import React, { useState, useEffect } from "react";
// import BasicContext from '../BasicContext';
import { Picker, InputItem, List } from 'antd-mobile';

import { PurposeNumber } from '../utils/const';

const rangerItem = (item) => {
  return {
    label: PurposeNumber[item],
    value: +item
  }
}

const options = Object.keys(PurposeNumber).sort().map(rangerItem);

export function PurposeFilter(props) {

  const { value, onChange, ...other } = props;
  // const context = useContext(BasicContext);

  const [filteredOptions, setOptions] = useState(options);

  const onSearchChange = (v) => {
    const filterOptions = (options).filter(item => (item.label + item.value).indexOf(v) >= 0);
    setOptions(filterOptions);
  }

  useEffect(() => {
    onSearchChange('');
  }, []);

  return <Picker
    title={<InputItem
      placeholder="短信类型"
      className="picker-search-input"
      style={{ width: "100%" }}
      clear={true}
      onChange={onSearchChange}
    />}
    itemStyle={{ fontSize: 14 }}
    data={filteredOptions}
    value={value}
    onChange={v => onChange(v)}
    cols={1}
    {...other}
  >
    <List.Item arrow="horizontal">短信类型</List.Item>
  </Picker>
}
